import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLayoutEffect, useState } from "react";
import SignUp from "./pages/SignUp/SignUp";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import SingleProduct from "./pages/SingleProduct/SingleProduct";
import ViewCart from "./pages/ViewCart/ViewCart";
import Checkout from "./pages/Checkout/Checkout";
import Invoices from "./pages/Invoices/Invoices";
import SuccessPage from "./pages/SuccessPage/SuccessPage";
import SingleInvoice from "./pages/SingleInvoice/SingleInvoice";

// MOBILE DESIGN
import LoginMobile from "./MobilePages/LoginMobile/LoginMobile";
import SignUpMobile from "./MobilePages/SignUpMobile/SignupMobile";
import HomeMobile from "./MobilePages/HomeMobile/HomeMobile";
import SingleInvoiceMobile from "./MobilePages/SingleInvoiceMobile/SingleInvoiceMobile";
import InvoicesMobile from "./MobilePages/InvoicesMobile/InvoicesMobile";
import SuccessPageMobile from "./MobilePages/SuccessPageMobile/SuccessPageMobile";
import CheckoutMobile from "./MobilePages/CheckoutMobile/CheckoutMobile";
import ViewCartMobile from "./MobilePages/ViewCartMobile/ViewCartMobile";
import SingleProductMobile from "./MobilePages/SingleProductMobile/SingleProductMobile";


function App() {

// LOGIC FOR RESPONSIVE DESIGN
const [windowWidth, setWindowWidth] = useState(window.innerWidth);
const updateWindowWidth = () => {
  setWindowWidth(window.innerWidth);
};
useLayoutEffect(() => {
  window.addEventListener("resize", updateWindowWidth);
  return () => window.removeEventListener("resize", updateWindowWidth);
}, []);

const isDesktop = windowWidth > 576;




  return (
    <div className="App">
      <Router>
        <Routes>
        {isDesktop ? (
          <>
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Home />} />
            <Route path="/singleproduct/:productId" element={<SingleProduct />} />
            <Route path="/viewcart" element={<ViewCart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/Invoices" element={<Invoices />} />
            <Route path="/successpage" element={<SuccessPage />} />
            <Route path="/singleinvoice/:id" element={<SingleInvoice />} />
            </>
            ) : (
              <>
              <Route path="/login" element={<LoginMobile />} />
              <Route path="/signup" element={<SignUpMobile />} />
              <Route path="/home" element={<HomeMobile />} />
              <Route path="/" element={<HomeMobile />} />
              <Route path="/Invoices" element={<InvoicesMobile />} />
              <Route path="/singleinvoice/:id" element={<SingleInvoiceMobile />} />
              <Route path="/successpage" element={<SuccessPageMobile />} />
              <Route path="/checkout" element={<CheckoutMobile />} />
              <Route path="/viewcart" element={<ViewCartMobile />} />
              <Route path="/singleproduct/:productId" element={<SingleProductMobile />} />

              </>
              )}

        </Routes>
      </Router>
    </div>
  );
}

export default App;
